// 必须最先执行：过滤扩展脚本导致的「假崩溃」红屏（与 Capacitor / 业务无关）
import './devExtensionNoiseFilter';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { initCapacitorIosOverscrollClass } from './utils/capacitorIosOverscroll';
import { bootstrapNativePreferences } from './utils/nativePreferences';
import App from './App';

initCapacitorIosOverscrollClass();

async function startApp() {
  try {
    await bootstrapNativePreferences();
  } catch (e) {
    console.warn('[startApp] bootstrapNativePreferences', e);
  }
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(<App />);
}

startApp();